import {
  Row,
  Col,
  Card,
  Radio,
  Table,
  Alert,
  // message,
  // Progress,
  Button,
  Avatar,
  Typography,
} from "antd";

import { TeamOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
// import Counter from "react-number-counter";

// Images
// import ava1 from "../../assets/images/bitcoin.png";
import ava2 from "../../assets/images/ethereum.png";
// import ava3 from "../../assets/images/cardano.png";
import ava4 from "../../assets/images/binancee.png";
import ava5 from "../../assets/images/solana.png";
// import ava6 from "../../assets/images/polkadot.png";
import ava7 from "../../assets/images/polygon matic.png";
import ava8 from "../../assets/images/ether.png";
import face2 from "../../assets/images/avax.png";
// import face3 from "../../assets/images/face-3.jpg";
// import face4 from "../../assets/images/face-4.jpg";
// import face5 from "../../assets/images/face-5.jpeg";
// import face6 from "../../assets/images/face-6.jpeg";
// import pencil from "../../assets/images/pencil.svg";
import { Lending_message } from "../../assets/Texts";

const { Title } = Typography;

// const formProps = {
//   name: "file",
//   action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
//   headers: {
//     authorization: "authorization-text",
//   },
//   onChange(info) {
//     if (info.file.status !== "uploading") {
//       console.log(info.file, info.fileList);
//     }
//     if (info.file.status === "done") {
//       message.success(`${info.file.name} file uploaded successfully`);
//     } else if (info.file.status === "error") {
//       message.error(`${info.file.name} file upload failed.`);
//     }
//   },
// };
// table code start
const columns = [
  {
    title: "CONTRACT",
    dataIndex: "name",
    key: "name",
    width: "32%",
  },
  {
    title: "NEEDED",
    dataIndex: "function",
    key: "function",
  },

  {
    title: "",
    key: "status",
    dataIndex: "status",
  },
  {
    title: "TIME-FRAME",
    key: "employed",
    dataIndex: "employed",
  },
];

// const dataproject = [
//   {
//     key: "1",

//     name: (
//       <>
//         <Avatar.Group>
//           <Avatar className="shape-avatar" src={ava1} size={25} alt="" />
//           <div className="avatar-info">
//             <Title level={5}>Spotify Version</Title>
//           </div>
//         </Avatar.Group>
//       </>
//     ),
//     age: (
//       <>
//         <div className="semibold">$14,000</div>
//       </>
//     ),
//     address: (
//       <>
//         <div className="text-sm">working</div>
//       </>
//     ),
//     completion: (
//       <>
//         <div className="ant-progress-project">
//           <Progress percent={30} size="small" />
//           <span>
//             <Link to="/">
//               <img src={pencil} alt="" />
//             </Link>
//           </span>
//         </div>
//       </>
//     ),
//   },

//   {
//     key: "2",
//     name: (
//       <>
//         <Avatar.Group>
//           <Avatar className="shape-avatar" src={ava2} size={25} alt="" />
//           <div className="avatar-info">
//             <Title level={5}>Progress Track</Title>
//           </div>
//         </Avatar.Group>
//       </>
//     ),
//     age: (
//       <>
//         <div className="semibold">$3,000</div>
//       </>
//     ),
//     address: (
//       <>
//         <div className="text-sm">working</div>
//       </>
//     ),
//     completion: (
//       <>
//         <div className="ant-progress-project">
//           <Progress percent={10} size="small" />
//           <span>
//             <Link to="/">
//               <img src={pencil} alt="" />
//             </Link>
//           </span>
//         </div>
//       </>
//     ),
//   },

//   {
//     key: "3",
//     name: (
//       <>
//         <Avatar.Group>
//           <Avatar className="shape-avatar" src={ava3} size={25} alt="" />
//           <div className="avatar-info">
//             <Title level={5}> Jira Platform Errors</Title>
//           </div>
//         </Avatar.Group>
//       </>
//     ),
//     age: (
//       <>
//         <div className="semibold">Not Set</div>
//       </>
//     ),
//     address: (
//       <>
//         <div className="text-sm">done</div>
//       </>
//     ),
//     completion: (
//       <>
//         <div className="ant-progress-project">
//           <Progress percent={100} size="small" format={() => "done"} />
//           <span>
//             <Link to="/">
//               <img src={pencil} alt="" />
//             </Link>
//           </span>
//         </div>
//       </>
//     ),
//   },

//   {
//     key: "4",
//     name: (
//       <>
//         <Avatar.Group>
//           <Avatar className="shape-avatar" src={ava5} size={25} alt="" />
//           <div className="avatar-info">
//             <Title level={5}> Launch new Mobile App</Title>
//           </div>
//         </Avatar.Group>
//       </>
//     ),
//     age: (
//       <>
//         <div className="semibold">$20,600</div>
//       </>
//     ),
//     address: (
//       <>
//         <div className="text-sm">canceled</div>
//       </>
//     ),
//     completion: (
//       <>
//         <div className="ant-progress-project">
//           <Progress
//             percent={50}
//             size="small"
//             status="exception"
//             format={() => "50%"}
//           />
//           <span>
//             <Link to="/">
//               <img src={pencil} alt="" />
//             </Link>
//           </span>
//         </div>
//       </>
//     ),
//   },

//   {
//     key: "5",
//     name: (
//       <>
//         <Avatar.Group>
//           <Avatar className="shape-avatar" src={ava5} size={25} alt="" />
//           <div className="avatar-info">
//             <Title level={5}>Web Dev</Title>
//           </div>
//         </Avatar.Group>
//       </>
//     ),
//     age: (
//       <>
//         <div className="semibold">$4,000</div>
//       </>
//     ),
//     address: (
//       <>
//         <div className="text-sm">working</div>
//       </>
//     ),
//     completion: (
//       <>
//         <div className="ant-progress-project">
//           <Progress percent={80} size="small" />
//           <span>
//             <Link to="/">
//               <img src={pencil} alt="" />
//             </Link>
//           </span>
//         </div>
//       </>
//     ),
//   },

//   {
//     key: "6",
//     name: (
//       <>
//         <Avatar.Group>
//           <Avatar className="shape-avatar" src={ava6} size={25} alt="" />
//           <div className="avatar-info">
//             <Title level={5}>Redesign Online Store</Title>
//           </div>
//         </Avatar.Group>
//       </>
//     ),
//     age: (
//       <>
//         <div className="semibold">$2,000</div>
//       </>
//     ),
//     address: (
//       <>
//         <div className="text-sm">canceled</div>
//       </>
//     ),
//     completion: (
//       <>
//         <div className="ant-progress-project">
//           <Progress percent={0} size="small" />
//           <span>
//             <Link to="/">
//               <img src={pencil} alt="" />
//             </Link>
//           </span>
//         </div>
//       </>
//     ),
//   },
// ];

function LendingInfo() {
  // const onChange = (e) => console.log(`radio checked:${e.target.value}`);let history = useHistory();

  let value = "a";
  let handleCLicked = (e) => {
    value = e.target.value;
    if (value === "b") {
      // history.replace("/sign-in");
    } else {
      if (value === "c") {
        // history.push("/sign-in");
      }
    }
  };

  // let updatevalues = (oldvalue, newvalue, setter) => {
  //   if (newvalue > oldvalue) {
  //     for (let i = 1; i <= newvalue - oldvalue; i++) {
  //       setInterval(() => {
  //         setter(() => oldvalue + i);
  //       }, 10000);
  //     }
  //   } else {
  //     if (newvalue < oldvalue) {
  //       for (let i = 1; i <= oldvalue - newvalue; i++) {
  //         setInterval(() => {
  //           setter(() => oldvalue - i);
  //         }, 10000);
  //       }
  //     } else {
  //     }
  //   }
  // };
  const data = [
    {
      key: "1",
      name: (
        <>
          <Avatar.Group>
            <Avatar
              className="shape-avatar"
              shape="square"
              size={40}
              src={ava2}
            ></Avatar>
            <div className="avatar-info">
              <Title level={5}>Moore-Thony</Title>
              <p>ETH</p>
            </div>
          </Avatar.Group>{" "}
        </>
      ),
      function: (
        <>
          <div className="author-info">
            <Title level={5}>$1000</Title>
            <p>3% - month</p>
          </div>
        </>
      ),

      status: (
        <>
          <Link to="/sign-in">
            <Button type="primary" className="tag-primary">
              FUND
            </Button>
          </Link>
        </>
      ),
      employed: (
        <>
          <div className="ant-employed">
            <span>3 months</span>
            <div style={{ marginLeft: 10 }}>
              <Button
                type="primary"
                shape="circle"
                icon={<TeamOutlined />}
                size="small"
              />
            </div>
          </div>
        </>
      ),
    },

    {
      key: "2",
      name: (
        <>
          <Avatar.Group>
            <Avatar
              className="shape-avatar"
              shape="square"
              size={40}
              src={ava2}
            ></Avatar>
            <div className="avatar-info">
              <Title level={5}>Hassan-Haruna</Title>
              <p>ETH</p>
            </div>
          </Avatar.Group>{" "}
        </>
      ),
      function: (
        <>
          <div className="author-info">
            <Title level={5}>$3000</Title>
            <p>1.5% - month</p>
          </div>
        </>
      ),

      status: (
        <>
          <Link to="/sign-in">
            <Button type="primary" className="tag-primary">
              FUND
            </Button>
          </Link>
        </>
      ),
      employed: (
        <>
          <div className="ant-employed">
            <span>5 months</span>
            <div style={{ marginLeft: 10 }}>
              <Button
                type="primary"
                shape="circle"
                icon={<TeamOutlined />}
                size="small"
              />
            </div>
          </div>
        </>
      ),
    },

    {
      key: "3",
      name: (
        <>
          <Avatar.Group>
            <Avatar
              className="shape-avatar"
              shape="square"
              size={40}
              src={ava7}
            ></Avatar>
            <div className="avatar-info">
              <Title level={5}>JLMC</Title>
              <p>POLYGON</p>
            </div>
          </Avatar.Group>{" "}
        </>
      ),
      function: (
        <>
          <div className="author-info">
            <Title level={5}>$1500</Title>
            <p>5% - month</p>
          </div>
        </>
      ),

      status: (
        <>
          <Link to="/sign-in">
            <Button type="primary" className="tag-primary">
              FUND
            </Button>
          </Link>
        </>
      ),
      employed: (
        <>
          <div className="ant-employed">
            <span>6 months</span>
            <div style={{ marginLeft: 10 }}>
              <Button
                type="primary"
                shape="circle"
                icon={<TeamOutlined />}
                size="small"
              />
            </div>
          </div>
        </>
      ),
    },
    {
      key: "4",
      name: (
        <>
          <Avatar.Group>
            <Avatar
              className="shape-avatar"
              shape="square"
              size={40}
              src={ava5}
            ></Avatar>
            <div className="avatar-info">
              <Title level={5}>Alvaro-Avie-Jose</Title>
              <p>SOL</p>
            </div>
          </Avatar.Group>{" "}
        </>
      ),
      function: (
        <>
          <div className="author-info">
            <Title level={5}>$8000</Title>
            <p>10% - month</p>
          </div>
        </>
      ),

      status: (
        <>
          <Link to="/sign-in">
            <Button type="primary" className="tag-primary">
              FUND
            </Button>
          </Link>
        </>
      ),
      employed: (
        <>
          <div className="ant-employed">
            <span>10 months</span>
            <div style={{ marginLeft: 10 }}>
              <Button
                type="primary"
                shape="circle"
                icon={<TeamOutlined />}
                size="small"
              />
            </div>
          </div>
        </>
      ),
    },
    {
      key: "5",
      name: (
        <>
          <Avatar.Group>
            <Avatar
              className="shape-avatar"
              shape="square"
              size={40}
              src={ava5}
            ></Avatar>
            <div className="avatar-info">
              <Title level={5}>NadirNJBXW</Title>
              <p>SOL</p>
            </div>
          </Avatar.Group>{" "}
        </>
      ),
      function: (
        <>
          <div className="author-info">
            <Title level={5}>$12000</Title>
            <p>6% - month</p>
          </div>
        </>
      ),

      status: (
        <>
          <Link to="/sign-in">
            <Button type="primary" className="tag-primary">
              FUND
            </Button>
          </Link>
        </>
      ),
      employed: (
        <>
          <div className="ant-employed">
            <span>3 months</span>
            <div style={{ marginLeft: 10 }}>
              <Button
                type="primary"
                shape="circle"
                icon={<TeamOutlined />}
                size="small"
              />
            </div>
          </div>
        </>
      ),
    },

    {
      key: "6",
      name: (
        <>
          <Avatar.Group>
            <Avatar
              className="shape-avatar"
              shape="square"
              size={40}
              src={ava4}
            ></Avatar>
            <div className="avatar-info">
              <Title level={5}>J sun Chai</Title>
              <p>BSC</p>
            </div>
          </Avatar.Group>{" "}
        </>
      ),
      function: (
        <>
          <div className="author-info">
            <Title level={5}>$6000</Title>
            <p>4.5% - month</p>
          </div>
        </>
      ),

      status: (
        <>
          <Link to="/sign-in">
            <Button type="primary" className="tag-primary">
              FUND
            </Button>
          </Link>
        </>
      ),
      employed: (
        <>
          <div className="ant-employed">
            <span>5 months</span>
            <div style={{ marginLeft: 10 }}>
              <Button
                type="primary"
                shape="circle"
                icon={<TeamOutlined />}
                size="small"
              />
            </div>
          </div>
        </>
      ),
    },
    {
      key: "7",
      name: (
        <>
          <Avatar.Group>
            <Avatar
              className="shape-avatar"
              shape="square"
              size={40}
              src={ava8}
            ></Avatar>
            <div className="avatar-info">
              <Title level={5}>Belinda-zury</Title>
              <p>ARBITRUM</p>
            </div>
          </Avatar.Group>{" "}
        </>
      ),
      function: (
        <>
          <div className="author-info">
            <Title level={5}>$5500</Title>
            <p>5.5% - month</p>
          </div>
        </>
      ),

      status: (
        <>
          <Link to="/sign-in">
            <Button type="primary" className="tag-primary">
              FUND
            </Button>
          </Link>
        </>
      ),
      employed: (
        <>
          <div className="ant-employed">
            <span>5 months</span>
            <div style={{ marginLeft: 10 }}>
              <Button
                type="primary"
                shape="circle"
                icon={<TeamOutlined />}
                size="small"
              />
            </div>
          </div>
        </>
      ),
    },
    {
      key: "8",
      name: (
        <>
          <Avatar.Group>
            <Avatar
              className="shape-avatar"
              shape="square"
              size={40}
              src={face2}
            ></Avatar>
            <div className="avatar-info">
              <Title level={5}>Wazirisembi</Title>
              <p>AVAX</p>
            </div>
          </Avatar.Group>{" "}
        </>
      ),
      function: (
        <>
          <div className="author-info">
            <Title level={5}>$4000</Title>
            <p>7.5% - month</p>
          </div>
        </>
      ),

      status: (
        <>
          <Link to="/sign-in">
            <Button type="primary" className="tag-primary">
              FUND
            </Button>
          </Link>
        </>
      ),
      employed: (
        <>
          <div className="ant-employed">
            <span>8 months</span>
            <div style={{ marginLeft: 10 }}>
              <Button
                type="primary"
                shape="circle"
                icon={<TeamOutlined />}
                size="small"
              />
            </div>
          </div>
        </>
      ),
    },
  ];

  const [newdata, setNewdata] = useState([]);

  const randomizeData = () => {
    let getRandomValue = (i, N) => Math.floor(Math.random() * (N - i) + i);

    // Shuffle a pair of two elements at random position j
    data.forEach(
      (elem, i, arr, j = getRandomValue(i, arr.length)) =>
        ([arr[i], arr[j]] = [arr[j], arr[i]])
    );
    setNewdata(data);
  };

  // let updateall = () => {
  //   updatevalues(pricea, 3000, setPricea);
  // };

  useEffect(() => {
    // console.log("using effect");
    randomizeData();
    const interval = setInterval(() => {
      randomizeData();
    }, 20000);

    return () => clearInterval(interval);
  }, []);

  // useEffect(() => {
  //   // console.log("using effects");
  //   updateall();
  // });

  return (
    <>
      <Alert
        message="About Lending"
        description={Lending_message}
        type="info"
        showIcon
        closable
      />
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Lend"
              extra={
                <>
                  <Radio.Group
                    defaultValue="a"
                    onChange={(e) => handleCLicked(e)}
                  >
                    <Radio.Button value="b">ALL</Radio.Button>
                    {/* <Radio.Button value="c">CONTACT</Radio.Button> */}
                  </Radio.Group>
                </>
              }
            >
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={newdata}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>

            {/* <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Projects Table"
              extra={
                <>
                  <Radio.Group onChange={onChange} defaultValue="all">
                    <Radio.Button value="all">All</Radio.Button>
                    <Radio.Button value="online">ONLINE</Radio.Button>
                    <Radio.Button value="store">STORES</Radio.Button>
                  </Radio.Group>
                </>
              }
            >
              <div className="table-responsive">
                <Table
                  columns={project}
                  dataSource={dataproject}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
              <div className="uploadfile pb-15 shadow-none">
                <Upload {...formProps}>
                  <Button
                    type="dashed"
                    className="ant-full-box"
                    icon={<ToTopOutlined />}
                  >
                    Click to Upload
                  </Button>
                </Upload>
              </div>
            </Card> */}
          </Col>
        </Row>
      </div>
    </>
  );
}

export default LendingInfo;
